import type { EditorState } from '#packages/stateManagement';

const isLayersPanelDisplayed = (state: EditorState): boolean =>
  state.layersPanel.isLayersPanelDisplayed;

const getOrigin = (state: EditorState): string => state.layersPanel.origin;

export { isLayersPanelDisplayed, getOrigin };
